import React, { useState } from "react";
import { Mail, Phone } from "lucide-react";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: "", email: "", company: "", mobile: "", robot: false,
  });

  const buildMailto = () => {
    const subject = encodeURIComponent("Contact - Somm.ai");
    const lines = [
      "Hi David,",
      "",
      "I'd like to get in touch with Somm.ai.",
      "",
      form.name ? `Name: ${form.name}` : "",
      form.email ? `Email: ${form.email}` : "",
      form.company ? `Company: ${form.company}` : "",
      form.mobile ? `Mobile: ${form.mobile}` : "",
      "",
      "Thanks!",
    ].filter(Boolean);
    const body = encodeURIComponent(lines.join("\n"));
    return `mailto:david@somm.ai?subject=${subject}&body=${body}`;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!form.robot) { alert("Please confirm you're not a robot"); return; }
    window.location.href = buildMailto();
    setSubmitted(true);
  };

  return (
    <div style={{ background: "#f5f6f8" }}>
      {/* Hero */}
      <section className="max-w-5xl mx-auto px-6 pt-20 pb-10 text-center">
        <div className="text-[13px] font-semibold tracking-[0.14em] uppercase" style={{ color: "#2552ff" }}>contact</div>
        <h1 className="hero-title mt-4 text-5xl md:text-7xl">Let’s Talk</h1>
        <p className="mt-5 text-lg text-[#4b5566]">We’d love to talk about how we can work together.</p>
      </section>

      {/* Form */}
      <section className="max-w-5xl mx-auto px-6 pb-16">
        <div className="card-soft p-8 md:p-12 bg-white">
          {submitted ? (
            <div className="text-center py-20">
              <div className="text-3xl font-extrabold">Thank you!</div>
              <div className="mt-3 text-[#4b5566]">Your submission has been received. We’ll get back to you shortly.</div>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold mb-2">Full name</label>
                  <input className="form-input" placeholder="Frank Castle" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">Your email</label>
                  <input className="form-input" type="email" placeholder="franklyfrank@example.com" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold mb-2">Company name</label>
                  <input className="form-input" placeholder="The P-Corp." value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2">Mobile number</label>
                  <input className="form-input" placeholder="+1 012 345 6789" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} />
                </div>
              </div>
              <label className="flex items-center gap-3 p-4 border border-[#e7ecf3] rounded-lg max-w-sm bg-[#f9fafc]">
                <input type="checkbox" checked={form.robot} onChange={(e) => setForm({ ...form, robot: e.target.checked })} />
                <span className="text-sm">I’m not a robot</span>
                <span className="ml-auto text-xs text-[#7a8499]">reCAPTCHA</span>
              </label>
              <button type="submit" className="btn-green justify-center" style={{ display: "inline-flex" }}>Send message</button>
            </form>
          )}
        </div>
      </section>

      {/* Contact info cards */}
      <section className="max-w-5xl mx-auto px-6 pb-16 grid md:grid-cols-2 gap-6">
        <div className="card-soft p-8 bg-white">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: "#eaf1ff", color: "#2552ff" }}><Mail size={20}/></div>
          <div className="mt-5 text-lg font-bold">Message us</div>
          <a href="mailto:hello@somm.ai" className="text-[#4b5566] hover:text-[#22c55e]">hello@somm.ai</a>
        </div>
        <div className="card-soft p-8 bg-white">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: "#e8faef", color: "#16a34a" }}><Phone size={20}/></div>
          <div className="mt-5 text-lg font-bold">Call us</div>
          <a href="tel:+13475140591" className="text-[#4b5566] hover:text-[#22c55e]">+1 347 514 0591</a>
        </div>
      </section>
    </div>
  );
}
